import { render, staticRenderFns } from "./MetricTabsWithContent.vue?vue&type=template&id=2ec72978&scoped=true"
import script from "./MetricTabsWithContent.vue?vue&type=script&lang=ts"
export * from "./MetricTabsWithContent.vue?vue&type=script&lang=ts"
import style0 from "./MetricTabsWithContent.vue?vue&type=style&index=0&id=2ec72978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec72978",
  null
  
)

export default component.exports